module.exports = __webpack_public_path__ + "./assets/hawksoft_logo_with_subtitle.png";